<template>
<div id="dashboard">
<div v-if="!states.viewAllow && !states.showFail" class="loader overlay">
    <img class="overlay-container" src="@/assets/img/loader.gif" />
  </div>
  <div v-if="states.showFail">
    <p></p>
      <div v-if="states.onServerError" class="text-center">
      <label>Došlo k neočakávanej chybe. Skúste neskôr.</label>
      </div>
      <div v-else>
      <p class="text-center" v-if="tplData.general"><label v-html="tpl('general.errorLoading')"></label></p>
      </div>
  </div>
  <div v-if="states.viewAllow" class="row">
    <div v-show="states.isPredplatenka" class="large-12 medium-12 small-12 columns">
      <div v-if="states.mainView"><p></p>
      <h2>TELEKOM PREDPLATENKA</h2>
      <hr/>

Vážený zákazník,
<br/>
<br/>
ďakujeme, že ste si vybrali Predplatenku od Telekomu – bez viazanosti, faktúr a mesačných poplatkov. Predplatenka ponúka nekonečné volania, SMS a dáta za skvelé ceny. To všetko prehľadne a hneď poruke vďaka Telekom aplikácii.
<br/>
<span class="magenta" v-show="!consumed">Na úvod si vyberte bezplatný balík na prvých 30 dní:</span>
<div v-show="consumed" class="magenta"><strong>Benefit ste už využili, bezplatná aktivácia nieje možná. Prejdite na <router-link to="/balicky">ponuku balíčkov.</router-link></strong></div>
      <p></p>
      <div class="sPkg" v-for="sPkg in homeDef.data" :key="sPkg.bucketName" >
        <div class="sub-content pcg-list" v-on:click="pcgVis(sPkg.bucketName)">
          <div class="pcg-block-left">
            <div class="radio">
              <span v-bind:class="{ checked: sPkg.isChecked}"><input type="radio"></span>
            </div>
          </div>
          <div class="pcg-block-right">
          <span>
          <span class="pcg-title">{{sPkg.readable}}<br/></span>
                  <div v-html="sPkg.newDesc.infoText" style="width:82%"></div>
                  <div v-html="sPkg.newDesc.valTextFree"></div>
          </span>
          <span class="pcg_right" v-html="formatPrice(sPkg.price, !sPkg.isActive)">
          </span>
          </div>
        </div>
          <div v-show="sPkg.isChecked" class="pkg_container">
          <div class="pkg_desc">
            <span class="fet" v-show="sPkg.isActive" v-html="sPkg.newDesc.currStateText"></span>
            <div v-html="sPkg.newDesc.longTextFree"></div>
            <p></p>
            <div v-show="!homeDef.data.oappOnly">Platí do <strong><span v-html="sPkg.newDesc.valText"></span></strong></div>
          </div>
          <a class="a_btn" disabled="disabled" v-bind:class="{ a_action: !sPkg.oappOnly, a_info: sPkg.oappOnly }" v-on:click = "callAction('start'), states.pkgAction=sPkg.bucketName" v-html="sPkg.btnText"></a>
          </div>
        </div>

      <div class="sPkg" v-for="vPkg in homeDef.voice" :key="vPkg.bucketName">
        <div class="sub-content pcg-list" v-on:click="pcgVis(vPkg.bucketName)">
          <div class="pcg-block-left">
            <div class="radio">
              <span v-bind:class="{ checked: vPkg.isChecked}"><input type="radio"></span>
            </div>
          </div>
          <div class="pcg-block-right">
          <span>
          <span class="pcg-title">{{vPkg.readable}}<br/></span>
                  <div v-html="vPkg.newDesc.infoText" style="width:82%"></div>
                  <div v-html="vPkg.newDesc.valTextFree"></div>
          </span>
          <span class="pcg_right" v-html="formatPrice(vPkg.price, !vPkg.isActive)">
          </span>
          </div>
        </div>
          <div v-show="vPkg.isChecked" class="pkg_container">
          <div class="pkg_desc">
            <span class="fet" v-show="vPkg.isActive" v-html="vPkg.newDesc.currStateText"></span>
            <div v-html="vPkg.newDesc.longTextFree"></div>
            <p></p>
            <div v-show="!vPkg.oappOnly">Platí do <strong><span v-html="vPkg.newDesc.valText"></span></strong></div>
          </div>
          <a class="a_btn" v-bind:class="{ a_action: !vPkg.oappOnly, a_info: vPkg.oappOnly }" v-on:click = "callAction('start'), states.pkgAction=vPkg.bucketName" v-html="vPkg.btnText"></a>
          </div>
        </div>
        <p>Pre viac informácií o programe služieb Predplatenka kliknite na <a href="https://www.telekom.sk/osobne/pomoc-a-podpora/dokumenty-a-pravne-informacie/dokumenty-na-stiahnutie/cenniky-sluzieb-mobilnej-siete/" target="disc">www.telekom.sk/osobne/pomoc-a-podpora/dokumenty-a-pravne-informacie/dokumenty-na-stiahnutie/cenniky-sluzieb-mobilnej-siete</a></p>
        <p>Objavte skvelú ponuku <router-link to="/balicky">doplnkových balíkov</router-link>, s ktorými môžete volať a dátovať ešte výhodnejšie. Všetky informácie o Vašej Predplatenke nájdete na  <a href="http://www.predplatenka.sk/" target="disc">www.predplatenka.sk</a></p>
    <p></p>
    </div>
    <activations v-if="states.activationsView" :states="states" :productdetail="productdetail" :tplData="tplData" :pkgDef="pkgDef" :nextPacks=[]></activations>
    </div>
    <div v-show="!states.isPredplatenka">
      <p><br /></p><p class="text-center"><label>TVOJ AKUÁLNY PROGRAM NEUMOŽŇUJE VYUŽITIE AKCIE.</label></p><p></p><p class="text-center"><router-link to="/zmena-programu">Prejdi na novú Predplatenku.</router-link></p>
   </div>
    <p></p>
  </div>
</div>
</template>

<script>
import moment from 'moment'
import pkgDef from '@/assets/js/pkgDef'
import Activations from '@/components/balickyaction'

export default {
  name: 'Vitajte',
  components: {
    Activations
  },
  data () {
    return {
      msg: 'Vitajte',
      seen: false,
      tplData: {},
      tpl: function(tpath) {
        const inObj = _.get(this.tplData, tpath); var res = null
        if (inObj) {res = inObj
        } else {
          res = tpath.toString()
        } return res
      },
      states: {
        viewAllow: false, showWait: true, showFail: false, isPredplatenka: false, activationsView: false, directAction: 'start', mainView: true, onServerError:false
      },
      msisdn: '',
      productdetail: {},
      pkgDef: pkgDef,
      consumed: false,
      homeDef: { data: [], voice: [] }
    }
  },
  created: function() {
    var that = this
    that.pkgDef = that.pkgDef.tkarta

    if (document.getElementById("msisdnTextSpan") === null) {
      var msisdnTextSpan = document.createElement("span")
      msisdnTextSpan.id = "msisdnTextSpan"
      var msisdnTemp = document.getElementById("jsHolder")
      msisdnTemp.appendChild(msisdnTextSpan)
    }  else {
      var msisdnTextSpan = document.getElementById("msisdnTextSpan")
    }

    var productDetailAllow = false, tplDataAllow = false;

    if (_.isEmpty(this.$store.state.productdetail)) {
      that.$store.dispatch('refreshProductDetail').then(() => {
       if (that.$store.state.httpCodes.productdetail === 200) {
          that.productdetail = that.$store.state.productdetail
          that.msisdn = that.$store.state.productdetail.msisdn
          msisdnTextSpan.innerHTML = '0' + that.msisdn.toString().substring(3)
       }        
       if (that.$store.state.httpCodes.productdetail === 403) {
          window.location.href = '/prihlasenie/?url=' + encodeURIComponent(that.$router.history.base + that.$route.fullPath)
       } else if (that.$store.state.httpCodes.productdetail === 400) {
          window.location.href = '/spotreba'
       } else if (that.$store.state.httpCodes.productdetail === 502) {
          that.states.showFail = true
          that.states.onServerError = true
       } else if (_.isEmpty(that.productdetail)) {
            that.states.showFail = true
       } else {
            productDetailAllow = true
            if (tplDataAllow) {
              this.setPecka()
            }
          }
      })
    } else {
        that.productdetail = that.$store.state.productdetail
        that.msisdn = that.$store.state.productdetail.msisdn
        msisdnTextSpan.innerHTML = '0' + that.msisdn.toString().substring(3)
        that.states.viewAllow = true
    }
    if (_.isEmpty(this.$store.state.tplData)) {
      that.$store.dispatch('refreshTplData').then(() => {
        that.tplData = that.$store.state.tplData
        tplDataAllow = true
        if (productDetailAllow) {
          this.setPecka()
        }
      });
    } else {
        that.tplData = that.$store.state.tplData
        this.setPecka()
    }

  },
  methods: {
    formatMsisdn: function(virgin) {
      return '0' + String(virgin).substring(3)
    },
    setPecka: function() {
      var that = this
      var daysAcc = ['nedele', 'pondelka', 'utorka', 'stredy', 'štvrtka', 'piatka', 'soboty']
      that.states.daysAcc = daysAcc
      if (((that.productdetail.product.productName).toLowerCase()).indexOf('t karta') !== -1) {
        that.states.isPredplatenka = true
      }

      let isConsumed = true, consumedCheck = false, eligBenefit = [];
      this.$http.get(this.$store.state.elgSrc)
      .then(function (resp) {
        if (resp.status == 200) {
          consumedCheck = true;
          if (_.isArray(resp.data)) {
            try {
            _.forEach(resp.data, function(v,k) {
              _.forEach(that.pkgDef, function(dv, dk) {
                if (v['bucketName'] == dv['offerBName']) {
                  dv.price = v.price
                  if (that.productdetail.benefit.indexOf(v['bucketName']) !== -1) {
                    eligBenefit.push(v['bucketName']);
                  }
                }
              })
            })
            } catch(e) { console.debug(e.message) }
          } 
        }
      }).catch(function(e){
        console.debug(e.response.status)
      }).then(function(){
        _.forEach(that.productdetail.benefit, function(bv, bk) {
          _.forEach(that.pkgDef, function(dv, dk) {
            if (bv == dv['offerBName']) {
              if (dv.price == 0) {
                isConsumed = consumedCheck ? (eligBenefit.indexOf(bv) === -1) : true;
              }
              that.homeDef[dv.type].push(dv);
            }
          })
        })
        that.consumed = isConsumed;
        for (var p in that.homeDef) {
          _.forEach(that.homeDef[p], function(hp, hk){
            if (that.tplData.package) {
              hp.desc = that.tplData.package[(hp.bucketName.toLowerCase().replace(/ /g, ''))]
              hp.readable = that.tplData.package.name[hp.bucketName] || hp.bucketName
            }
            hp.desc.valTextFree = _.isEmpty(hp.desc.valTextFree) ? "Platnosť: 30 dní" : hp.desc.valTextFree;
            hp.newDesc = {}
            hp.newDesc = _.clone(hp.desc)
            hp.newDesc.currStateText = "NEAKTÍVNY"
            if (hp.paralellDaysAdd == 0) {
            hp.newDesc.valText = 'dnes, '+ daysNom[(moment(that.productdetail.timeStamp).format('d'))] +' '+ moment(that.productdetail.timeStamp).format('D.M.YYYY') + " 23:59"
            } else {
            hp.newDesc.valText = daysAcc[(moment(that.productdetail.timeStamp).add((hp.paralellDaysAdd || 0), 'days').format('d'))] + ', ' + moment(that.productdetail.timeStamp).add((hp.paralellDaysAdd || 0), 'days').format('D.M.YYYY H:mm')
            }
            if (hp.oappOnly && that.tplData.package) {
              hp.newDesc.longText = "<strong>" + that.tplData.package.oappText + "</strong>"
            }
          })
        }
        that.states.viewAllow = true;
      })
    },    
    pcgVis: function(currPkg) {
      var getResize = document.getElementById('containerMain'), tLen = _.keys(this.homeDef).length, pi = 1
      var that = this
      if (!that.consumed) {
      for (let sType in this.homeDef) {
        _.forEach(this.homeDef[sType], function(pv, pk){
          if (pv.bucketName == currPkg) {
            pv.isChecked = !pv.isChecked
            if (pv.isChecked) {
              if (pi >= tLen) {
                setTimeout(function(){
                  document.getElementById('main').scrollTo(0, getResize.scrollHeight);
                }, 300)
              }   
              that.states.currPkg = pv
              that.states.pkgAction = pv.bucketName
            } 
          } else {
            pv.isChecked = false
          }
          pi++
        })
        }
      }
    },    
    formatPrice: function (virgin, active) {
      if ((active) || (this.states.rplnRel == "T")) {
        return parseFloat(virgin).toFixed(2).toString().replace(/\./, ',') + " €"
      } else {
        return "Aktívny"
      }
    },
    callAction: function(pAction) {
      this.states.activationsView = true
      this.states.directAction = pAction
      this.states.isDirect = true
      }
    }
}
</script>

<style scoped>
 .magenta {
   color: #E20074;
   font-weight: 400;
 }

.pcg-sub {
  border: 1px solid #E20074;
  position: relative;
  margin-bottom: 2rem;
}

.sub-content {
  width: 100%;
  display: flex;
  padding: 10px;
}

.pcg-sub .sub-heading {
  width: 100%;
  line-height: 2.4rem;
  color: #ffffff;
  background-color: #E20074;
  padding: 0 10px;
  font-size: 1.2rem;
  font-weight: bold;
}

.sPkg {
  margin-bottom: 1rem;
  position: relative;
  background-color: #ededed;
  box-shadow: 0 -2px 2px 0 #c4c4c4 inset
}

.pcg_right {
  position: absolute;
  right: 10px;
  top: 1.6rem;
  font-size: 1.7rem;
}

.pcg-block-left {
  flex: 0 0 40px;
  position: relative;
}

.pcg-block-right {
  flex: 1;
}

.pkg_desc {
  padding: 0 10px 10px 40px;
}

.pkg_container {
  padding: 10px 10px 4px 10px;
}

div.radio span {
  top: 27px;
}

a.a_btn {
  display: block;
  padding: 2px;
  margin: 5px 0;
  text-decoration: none;
  border-radius: 4px;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

a.a_btn.a_action {
  background-color: #6bb324;
  border: 2px solid #65ac20;  
  color: #ffffff;
}
a.a_btn.a_info {
  border: 2px solid #E20074;
  background-color: transparent;
  color: #E20074;
}
a.a_btn.a_action:active {
  border: 2px solid #58951c;
  background-color: #58951c;
}
a.a_btn.a_info:active{
  border: 2px solid #E20074;
  background-color: #E20074;
  color: #ffffff;
}
.pcg-title {
  text-transform: uppercase;
}
</style>
